"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _Heading = _interopRequireDefault(require("../Heading"));
var _LG = _interopRequireDefault(require("../Icons/ArrowLeftRight/LG"));
var _MD = _interopRequireDefault(require("../Icons/ArrowLeftRight/MD"));
var _SM = _interopRequireDefault(require("../Icons/ArrowLeftRight/SM"));
var _LG2 = _interopRequireDefault(require("../Icons/LongArrowRight/LG"));
var _MD2 = _interopRequireDefault(require("../Icons/LongArrowRight/MD"));
var _SM2 = _interopRequireDefault(require("../Icons/LongArrowRight/SM"));
var _Label = _interopRequireDefault(require("../Label"));
var _createStyles = require("../styles/createStyles");
const _excluded = ["classes", "size", "variant", "origin", "destination"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = exports.useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      position: 'relative'
    },
    labelWrapper: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      maxWidth: '20ch'
    },
    labelWrapperXs: {
      lineHeight: theme.busbud.spacing(2)
    },
    labelWrapperSm: {
      lineHeight: theme.busbud.spacing(2)
    },
    labelWrapperMd: {
      lineHeight: theme.busbud.spacing(2.5)
    },
    labelWrapperLg: {
      lineHeight: theme.busbud.spacing(3)
    },
    labelWrapperXl: {
      lineHeight: theme.busbud.spacing(4)
    },
    icon: {
      color: theme.busbud.colors.icon.primary.opaque,
      marginLeft: theme.busbud.spacing(0.5),
      marginRight: theme.busbud.spacing(0.5)
    }
  };
});
/**
 * **❗️ DEPRECATED**: Use `OriginDestinationLabel` from pubweb instead.
 *
 * OriginDestinationLabel displays the origin and destination with an directional arrow in between.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-typography-origindestinationlabel--page)
 *
 * @deprecated
 */
const OriginDestinationLabel = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      classes: classesOverrides,
      size = 'md',
      variant = 'one-way',
      origin,
      destination
    } = props,
    colorProp = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  const IconComponent = getIconComponent(size, variant);
  const LabelComponent = getLabelComponent(size);
  function getIconComponent(size, variant) {
    switch (size) {
      case 'xs':
      case 'sm':
      case 'md':
        return variant === 'roundtrip' ? _SM.default : _SM2.default;
      case 'lg':
        return variant === 'roundtrip' ? _MD.default : _MD2.default;
      case 'xl':
        return variant === 'roundtrip' ? _LG.default : _LG2.default;
      default:
        assertNever(size);
    }
  }
  const size_class_map = {
    xs: {
      class: classes.labelWrapperXs,
      component: _Label.default,
      size: 'sm'
    },
    sm: {
      class: classes.labelWrapperSm,
      component: _Label.default,
      size: 'md'
    },
    md: {
      class: classes.labelWrapperMd,
      component: _Label.default,
      size: 'lg'
    },
    lg: {
      class: classes.labelWrapperLg,
      component: _Label.default,
      size: 'xl'
    },
    xl: {
      class: classes.labelWrapperXl,
      component: _Heading.default,
      size: 'lg'
    }
  };
  const sizes = Object.keys(size_class_map);
  function getLabelComponent(size) {
    const LabelComponent = _ref2 => {
      let {
        children
      } = _ref2;
      if (!sizes.includes(size)) {
        console.error(`DSCL: Unknown size: ${size}`);
        return null;
      }
      const {
        component: Component,
        class: complementarClass,
        size: labelSize
      } = size_class_map[size];
      return /*#__PURE__*/React.createElement("span", {
        className: cx(classes.labelWrapper, complementarClass)
      }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
        size: labelSize,
        fontWeight: size !== 'xl' ? 'bold' : undefined,
        title: typeof children === 'string' ? children : undefined,
        component: "span"
      }, colorProp), children));
    };
    return LabelComponent;
  }
  return /*#__PURE__*/React.createElement("span", {
    ref: ref,
    className: cx(classes.root)
  }, /*#__PURE__*/React.createElement(LabelComponent, null, origin), /*#__PURE__*/React.createElement(IconComponent, (0, _extends2.default)({
    className: classes.icon
  }, colorProp)), /*#__PURE__*/React.createElement(LabelComponent, null, destination));
});
function assertNever(size) {
  throw new Error(`Impossible ${size}`);
}
var _default = exports.default = OriginDestinationLabel;